import React, { Component } from 'react';
import isArray  from 'lodash/isArray';

import { Input } from '@vds/inputs';
import Icon from '@vds/icons';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import './Unit.css';
import { withTranslation } from 'react-i18next';

const DropdownInput = styled(Input)`
    cursor: pointer;
    color: transparent;
    text-shadow: 0 0 0 #000000;
`;

class Unit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noLiveunit: false,
            selectedUnit: {},
            outSideClick: false,  // used for hiding unit suggestion list
            toggleDropdown: false, // used for toggling unit dropdown
            errorMessage: 'Please enter valid Unit #'
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.debouncedFn =  debounce((input) => {
            this.props.postUIEventLog({eventType: 'log', eventName: "Unit Change", sectionName: "LQ", log: input.unit});
        }, 500);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(props) {
        const {baseAddrUnitError, streetAdressInfo} = props;
        const addressId= streetAdressInfo.ntasAddrID;
        if (baseAddrUnitError && baseAddrUnitError !== this.props.baseAddrUnitError) {
            this.selectThisUnitOnClick({unit: "", addressId});
            const inputDiv = document.getElementById("unittextaheadsearch")?.getElementsByTagName("input")?.[0].focus();
            this.setState({ outSideClick: false, toggleDropdown: true });
        }
        // selectThisUnitOnClick

        if(props.totalUnits !=this.props.totalUnits && props.totalUnits ==1 ) {
            this.selectThisUnitOnClick(props.unitList[0], true);
        } 
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ outSideClick: true, toggleDropdown: false })
        }
    }

    selectThisUnit = (unit, eventType) => {
       
        if(eventType !== "blur") {
            this.props.getUnitsByUnitterm(unit.unit);
        }
        this.props.selectThisUnit(unit, eventType === "blur");
        this.props.resetDoLoopFlags();
        if(eventType !== "change"){
            const addressFound  = this.matchUnitAddress(unit);
            this.props.selectThisUnit(unit, eventType === "blur", addressFound);

            if(!addressFound) {
                this.setState({ outSideClick: false, toggleDropdown: false, selectedUnit: unit })
                if (unit === 'noLiveunit') {
                    this.setState({ noLiveunit: true })
                }
                if (unit !== 'noUnit' && unit !== 'noLiveunit') {
                    this.props.showCheckAvailability();
                }
                if(eventType === "blur") {
                    // this.props.validateUnits();
                }
            }
        }
        this.timer && clearInterval( this.timer);
        if(eventType === "blur") {
            this.setState({ outSideClick: true, toggleDropdown: false })
            this.debouncedFn(unit);
        } else {
            this.setState({ outSideClick: false, toggleDropdown: true })
        }
        if(eventType === "change" && unit?.unit !== ''){
            if(!this.props.unitList.some((unitObj) => unitObj?.unit === unit?.unit.toUpperCase())){
               this.props.setUnitError(true);
            }else{
               this.props.setUnitError(false);
            }
       }

    }

    matchUnitAddress = (unitObj) => {
        let unitFound = false;
        const {unitList} =  this.props;
        const {unit} = unitObj;
        if(unitList && isArray(unitList) && unit) {
            unitList.map((value, key) => { 
                if(this.formatString(value.unit) == this.formatString(unit)) { 
                    this.props.selectThisUnit(value);
                    unitFound = true;
                    this.setState({selectedUnit: unit});
                    this.setState({ outSideClick: true, toggleDropdown: false })
                    if (unit === 'noLiveunit') {
                        this.setState({ noLiveunit: true })
                    }
                    if (unit !== 'noUnit' && unit !== 'noLiveunit') {
                        this.props.showCheckAvailability();
                    }
                    this.props.triggerAddressQualification();
                }
            });
        }
        return unitFound;
    }

    selectThisUnitOnClick = (unit,eventName) => {
        this.props.selectThisUnit(unit);
        this.timer && clearInterval( this.timer);
        this.setState({selectedUnit: unit});
        this.setState({ outSideClick: true, toggleDropdown: false })
        if (unit === 'noLiveunit') {
            this.setState({ noLiveunit: true })
        }
        if (unit !== 'noUnit' && unit !== 'noLiveunit') {
            this.props.showCheckAvailability();
        }
        if (unit?.unit !== "") {
            this.props.triggerAddressQualification();
        }
        if(eventName==="change"){
            this.setState({ toggleDropdown: true }) 
        }
         this.props.postUIEventLog({eventType: 'log', eventName: "Unit Change", sectionName: "LQ", log: unit.unit});
    }

    handleSubmit = (e) => {
        e.preventDefault()
    }

    
    formatString = str => {
        return str ? str?.replace(/\s/g, '')?.replace(/,/g, '')?.toLowerCase()?.trim() : "";
    }

    renderInputList = () => {
        let unitList;
        let sortList = this.props.unitList?.sort((a,b) => a.unit > b.unit?1:-1);
        if (this.props.unitList && this.props.selectedUnit
            && this.props.selectedUnit.unit && !this.props.selectedUnit.addressId) {
                unitList = sortList.filter(bUnit => this.formatString(bUnit.unit).includes(this.formatString(this.props.selectedUnit.unit)))
            if (!unitList?.length && this.state.selectedUnit.unit !== this.props.selectedUnit.unit) {
                this.props.getUnitsByUnitterm(this.props.selectedUnit.unit)
            }
        }
        let showSuggestions = false;
        const inputDiv = document.getElementById("unittextaheadsearch");
        const input = inputDiv ? document.getElementById("unittextaheadsearch").getElementsByTagName("input")[0] : null
        const streetAdressInfo = this.props.streetAdressInfo;
        const addressId= streetAdressInfo.addressId;

        if(unitList && unitList?.length) {
            showSuggestions = !this.state.outSideClick || ( input && input === document.activeElement);
        } else {
            showSuggestions =  (input && input === document.activeElement &&  sortList && !!sortList?.length) || this.props.baseAddrUnitError || !this.state.toggleDropdown;
            if(showSuggestions) {
                unitList = sortList;
            }
        }
        const wirelineState = this.props.t("fios.wirelineState", { ns: "fios",returnObjects:true })
        if(this.props.showUnit && unitList && unitList.length && 
            ((wirelineState && typeof wirelineState == "object" && ((wirelineState.length && !wirelineState.includes(this.props.selectedStreetAddress?.state)) || (wirelineState.length === 0))) || !wirelineState || typeof wirelineState == 'string')
        ){
        const isUnitPresent = unitList&&unitList.find(data=>data['unit'] === "I don't live in a unit")
        if(!isUnitPresent){
            unitList = [...[{
                baseAddressId:"",
                addressId:"",
                unit:"I don't have a unit"
            }],
            ...unitList,
            ...[{
                baseAddressId:"",
                addressId:"",
                unit:"I don't see my unit"
            }]]
        }
        }
        const unitSuggestionList = (showSuggestions) ?
            <div ref={this.setWrapperRef} className="unit-suggestion-list">
                {Object.keys(unitList).map((key) => {
                    return (
                        <div className="suggestion-list-item" key={unitList[key].addressId} onClick={() => { 
                            
                            this.selectThisUnit({ unit: unitList[key].unit },"change");   
                            this.setState({selectedUnit: { unit: unitList[key].unit }});
                            this.forceUpdate();
                            this.selectThisUnitOnClick(unitList[key],"change")}}>
                        <span key={unitList[key].addressId} value={unitList[key].unit} onClick={() =>{  
                                this.selectThisUnit({ unit: unitList[key].unit },"change");   
                                this.setState({selectedUnit: { unit: unitList[key].unit}});
                                this.forceUpdate();
                            this.selectThisUnitOnClick(unitList[key],"change")}}>
                                {unitList[key].unit}
                            </span>
                        </div>
                    )
                })}
                {/* {!this.props.baseAddrUnitError && !this.props.iDontLiveUnit && (
                    <div className="suggestion-list-item" key={"IdontLiveinApt"} onClick={() => { this.selectThisUnitOnClick({unit: "I don't live in a unit", addressId})}}>
                        <span   value={{unit: ""}} onClick={() =>{  this.selectThisUnitOnClick({unit: "I don't live in a unit", addressId})}}>
                            {"I don't live in a unit"}
                        </span>
                    </div>)
                } */}
                
            </div> : '';

        return (
            <form onSubmit={this.handleSubmit} autocomplete="off" >
            <div style={{ position: "relative" }}  >
                <Input type="text" label="Enter your unit number (If appropriate)" 
                //  key={this.props.selectedUnit?.unit || ''}
                 id="unittextaheadsearch" 
                 placeholder="" name="myBrowser" width="100%" 
                onChange={(e) => {
                    this.selectThisUnit({ unit: e.target.value?e.target.value.toUpperCase():e.target.value },"change");   
                    this.setState({selectedUnit: { unit: e.target.value?e.target.value.toUpperCase():e.target.value }});}}
                onBlur={(e) => {
                    const self = this;
                    // const eVal =e.target.value;
                    this.timer = setTimeout(() => {
                        self.setState({outSideClick: true});
                    },2000);
                    // this.timer = setTimeout(() => {
                    //     self.selectThisUnit({ unit: self.props.selectedUnit.unit }, "blur");
                    // }, 2000)
                    }
                } 
                // value={this.props.selectedUnit && !this.props.baseAddrUnitError? this.props.selectedUnit.unit : ""} 
                errorEvent="change"
                onFocus={() => this.setState({outSideClick: false})}
                onPaste={ e => {this.selectThisUnit({ unit: e.target.value }, "paste")}}
                ref={this.props.inputRef}
             //   error={false}
               // defaultValue={this.state.selectedUnit?.unit || ''}
                value={this.props.selectedUnit && !this.props.baseAddrUnitError ? this.state.selectedUnit?.unit : this.props.totalUnits&&this.props.totalUnits>0? '':'Eg. Suite 200'}
                error={this.props.unitError || this.props.emptyUnitsError || this.props.baseAddrUnitError}
                errorText={this.props.baseAddrUnitError?'Please select valid Unit #': this.state.errorMessage}
                defaultValue={'Eg. Suite 200'}      
                style={this.props.selectedUnit ? {color:"#000000"} : {color:"#CCCCCC"} }   
                success={(this.props.unitError || this.props.emptyUnitsError || this.props.baseAddrUnitError)?false:this.props.selectedUnit?.unit?true:false}  
                data-track="lq unit bar click" 
                />
                {/* <span className= 'unit-help-text-address'> Eg. Suite 200 </span> */}
                <span  key={this.state.selectedUnit?.unit || ''}>{unitSuggestionList}</span>
            </div>
            </form>
        );
    };

    renderDropdownList = () => {
        let unitList = this.props.unitList?.sort((a,b) => a.unit > b.unit?1:-1);
        const wirelineState = this.props.t("fios.wirelineState", { ns: "fios",returnObjects:true })
        if(this.props.showUnit && unitList && unitList.length && 
            ((wirelineState && typeof wirelineState == "object" && ((wirelineState.length && !wirelineState.includes(this.props.selectedStreetAddress?.state)) || (wirelineState.length === 0))) || !wirelineState || typeof wirelineState == 'string')
        ){
            const isUnitPresent = unitList&&unitList.find(data=>data['unit'] === "I don't live in a unit")
            if(!isUnitPresent){
                unitList = [...[{
                    baseAddressId:"",
                    addressId:"",
                    unit:"I don't have a unit"
                }],
                ...unitList,
                ...[{
                    baseAddressId:"",
                    addressId:"",
                    unit:"I don't see my unit"
                }]]
            }
            }
        const { toggleDropdown } = this.state;
        console.log(this.props.totalUnits)
        return (
            <form onSubmit={this.handleSubmit} autocomplete="off">
            <div ref={this.setWrapperRef} style={{ position: "relative", width: "100%" }}>
                <div onClick={() => this.setState({ toggleDropdown: !toggleDropdown })}>
                    <div className="dropdown-align" data-track="lq unit bar click">
                    <DropdownInput label="Enter your unit number (If appropriate)" width="100%" 
                    placeholder={this.props.totalUnits&&this.props.totalUnits>0?"Select unit#":"No unit"} 
                    value={this.props.totalUnits&&this.props.totalUnits!==0 && this.props.selectedUnit ? this.props.selectedUnit.unit : 'Eg. Suite 200'}  
                    error={this.props.unitError ||  this.props.emptyUnitsError || this.props.baseAddrUnitError}
                    errorText={this.props.baseAddrUnitError?'Please select valid Unit #': this.state.errorMessage}
                    className={this.props.totalUnits&&this.props.totalUnits!==0?"":"unit-disabled"}   
                    defaultValue={'Eg. Suite 200'}
                    style={this.props.selectedUnit ? {color:"#000000"} : {color:"#CCCCCC"} } 
                    />
                          {/* <span className= 'unit-help-text-address'> Eg. Suite 200 </span> */}
                    </div>
                    {this.props.totalUnits?<span className="dropdown-caret">
                        <Icon name="caret-down" medium size="small" />
                    </span>:''}
                </div>
                {toggleDropdown && this.props.totalUnits!==0 &&
                    <div className="unit-suggestion-list">
                        {Object.keys(unitList).map(key => {
                            return (<div className="suggestion-list-item" data-track="lq unit suggestion click" key={unitList[key].addressId}  onClick={() => this.selectThisUnitOnClick(unitList[key], true)}>
                                <span key={unitList[key].addressId} value={unitList[key].unit} onClick={() => this.selectThisUnitOnClick(unitList[key], true)}>
                                    {unitList[key].unit}
                                </span>
                            </div>)
                        })}
                       {/* { !this.props.baseAddrUnitError && !this.props.iDontLiveUnit && (<div className="suggestion-list-item" onClick={() => this.selectThisUnitOnClick({unit: "I don't live in a unit"}, true)}>
                            <span  onClick={() => this.selectThisUnitOnClick({unit: "I don't live in a unit"}, true)}>
                                I don't live in a unit
                            </span>
                        </div>  )  } */}
                    </div>}
            </div>
            </form>
        )
    }

    render() {
        return (
            <div className="Units" >
                <div id="Unit-inputbox" className="Unit-inputbox">
                    {this.props.totalUnits > 10 ? this.renderInputList() : this.renderInputList()}
                </div>
                 {this.state.noLiveunit && <p>
                    Enter your contact information below to sign up for saved cart reminders and other ordering messages, as well as Verizon promotional emails. Entering a mobile number will also help us see if you qualify for 50% off Fios Gigabit connection and voice bundle offer.
                </p>}
            </div>
        );
    }
}

export default withTranslation("fios", { withRef: true })(Unit);
